import IService from '../IService';

export default IService.extend({
  getAllCategories() {
    const rv = new _.ColdPromise();
    $.ajax({
      url: app.apiUrl('/api/v1/storyTemplates/categories'),
      type: 'GET',

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      dataType: 'json',
      success(res) {
        if (!_.isEmpty(res)) {
          let categories = [];

          res.channelOwnedCategories = res.channelOwnedCategories
            ? res.channelOwnedCategories
            : [];
          res.inheritedChannelCategories = res.inheritedChannelCategories
            ? res.inheritedChannelCategories
            : [];

          res.inheritedChannelCategories =
            res.inheritedChannelCategories.filter(
              (c) => c.categoryType === 'SEGMENT'
            );

          if (res.organizationCategories?.length) {
            categories = res.organizationCategories;
          } else if (res.channelCategories?.length) {
            categories = res.channelCategories;
          }

          rv.resolve({
            categories,
            channelOwnedCategories: res.channelOwnedCategories,
            inheritedChannelCategories: res.inheritedChannelCategories,
          });
        } else {
          rv.reject({ error: 'BAD_RESPONSE' });
        }
      },
    });

    return rv;
  },

  postCategory(options = { categoryName: '' }) {
    const rv = new _.ColdPromise();
    $.ajax({
      url: app.apiUrl('/api/v1/storyTemplates/categories'),
      type: 'POST',
      data: { categoryName: options.categoryName },

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      dataType: 'json',
      success(category) {
        if (_.isObject(category)) {
          rv.resolve(category);
        } else {
          rv.reject({ error: 'BAD_RESPONSE' });
        }
      },
    });

    return rv;
  },

  deleteCategory(options = { categoryId: '' }) {
    const rv = new _.ColdPromise();
    $.ajax({
      url: app.apiUrl(
        `/api/v1/storyTemplates/categories/${options.categoryId}`
      ),
      type: 'DELETE',

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success() {
        rv.resolve();
      },
    });

    return rv;
  },

  putCategory(options = { categoryId: '', categoryName: '' }) {
    const rv = new _.ColdPromise();
    $.ajax({
      url: app.apiUrl(
        `/api/v1/storyTemplates/categories/${options.categoryId}`
      ),
      type: 'PUT',
      data: { categoryName: options.categoryName },

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success(category) {
        rv.resolve(category);
      },
    });

    return rv;
  },
});
